import React from 'react';

import { useTranslation } from 'providers/GILT.provider';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import parseMoney from 'utils/parsers/parseMoney.util';

// TODO: fix the no-param-reassign things, do not re-assign to the passed in props
const OrderItem = ({ onSaveChanges, orderInfo }) => {
  const { t } = useTranslation();
  const { quantity_update: quantityUpdate, product, quantity } = orderInfo;
  const { units_in_stock: unitsInStock } = product;

  const displayQuantityAfterUpdate = fromAnyToNumber(unitsInStock) + (quantityUpdate ? fromAnyToNumber(quantityUpdate) : 0);

  const u = fromAnyToNumber(unitsInStock);

  const displayQuantityAfterImport = parseMoney({ value: quantity + u }).coin.str;

  return (
    <div className="item-row">
      <div className="item-name">{`${product.title} ${product.status === 'deleted' ? t('stocks.ordersReceived.orderedItem.deleted') : ''}`}</div>
      <div className="item-current-q">{unitsInStock}</div>
      <div className="item-q-ordered">{quantity}</div>

      <div className="item-q-received">
        <div className="quantity-count">
          <span
            className="decr-btn"
            role="button"
            tabIndex={0}
            onClick={() => {
              if (quantityUpdate) {
                // eslint-disable-next-line no-param-reassign
                orderInfo.quantity_update = quantityUpdate - 1 >= 0 ? quantityUpdate - 1 : 0;
              } else if (quantityUpdate - 1 === -1) {
                // eslint-disable-next-line no-param-reassign
                orderInfo.quantity_update = quantity;
              } else {
                // eslint-disable-next-line no-param-reassign
                orderInfo.quantity_update = quantity - 1 >= 0 ? quantity - 1 : 0;
              }
              onSaveChanges(orderInfo);
            }}
          />

          {quantityUpdate || quantityUpdate === 0 ? quantityUpdate : quantity}

          <span
            className="incr-btn"
            role="button"
            tabIndex={0}
            onClick={() => {
              if (quantityUpdate) {
                // eslint-disable-next-line no-param-reassign
                orderInfo.quantity_update += 1;
              } else {
                // eslint-disable-next-line no-param-reassign
                orderInfo.quantity_update = quantity + 1;
              }
              onSaveChanges(orderInfo);
            }}
          />
        </div>
      </div>

      <div className="item-new-q">{quantityUpdate || quantityUpdate === 0 ? parseMoney({ value: displayQuantityAfterUpdate }).coin.str : displayQuantityAfterImport}</div>

      <div className="empty" />
    </div>
  );
};

export default OrderItem;
